import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { ExceptionalEvents } from '@/schemas/API/GET/employee/exceptional-event/response';

export default function useExceptionalEvents() {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: exceptionalEvents,
    error,
    mutate,
  } = useSWR<ExceptionalEvents>(
    employeeId ? `/employees/${employeeId}/exceptional-events` : null,
    async () =>
      await getFetcher(`/employees/${employeeId}/exceptional-events?size=500`)
  );

  return {
    exceptionalEvents,
    error,
    mutate,
  };
}
